/**
 * VireoHR - Layout Component
 * Wraps pages with Header and Bottom Navigation
 */

import { ReactNode } from 'react';

import BottomNavigation from './BottomNavigation';
import Header from './Header';
import { useAuth } from '../contexts/AuthContext';

interface LayoutProps {
  children: ReactNode;
  title: string;
  showSettings?: boolean;
}

export default function Layout({ children, title, showSettings = true }: LayoutProps) {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="min-h-screen bg-white">
      <Header title={title} showSettings={showSettings} />
      <main className="pb-20">{children}</main>
      <BottomNavigation role={user.role} />
    </div>
  );
}
